<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red accent-4"
                class="white--text"
                @click="confirmDialog = false"
                >{{ this.messageDismissButton }}</v-btn
              >
              <v-btn
                v-if="showConfirmButton"
                color="red accent-4"
                class="white--text"
                @click="deleteFromDatabase"
                >{{ this.messageConfirmButton }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

        <v-container>
            
        <merus-data-table
            :headers="headersPerfisWithProperties"
            :items="perfis"
            :loading="loadingPerfis"
            :loading-text="$t('system.messages.loading')"
            sort-by="descricao_tipo_usuario"
            dense
            class="elevation-7"
            locale="pt"
            style="border-radius: 10px"
            @update:displayedItems="displayedItemsForExport = $event"
        >

        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('profiles.usersTitle')"
                :token="token"
                :items="displayedItemsForExport !== null ? displayedItemsForExport : perfis"
                hide-search
            >
                <template v-slot:add>
                    <v-dialog v-model="dialog" max-width="100%">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            small
                            class="mb-2"
                            v-bind="attrs"
                            fab
                            v-on="{ ...on, click: (e) => { prepareNewPerfil(); if (on.click) on.click(e); } }"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        </template>
                    <v-card>
                    <v-card-title>
                        <span class="headline" style="color: #4a4a4a">{{
                            formTitle
                        }}</span>
                    </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="10" md="6">
                                                    <v-text-field v-model="editedItem.descricao_tipo_usuario"
                                                        single-line auto :label="$t('profiles.placeholder')"
                                                        :rules="[(v) => !!v || $t('profiles.required')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="2" md="2">
                                                    <v-autocomplete v-model="editedItem.id_home_page"
                                                        :label="$t('profiles.homeScreen')" :items="telas" item-text="cod_recurso"
                                                        item-value="id_recurso"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="2" md="2">
                                                    <v-text-field v-model="editedItem.expira_token"
                                                        :label="$t('profiles.tokenExpirationMinutes')" class="ma-2" type="number"
                                                        max="720"
                                                        :rules="[(v) => (!v || parseInt(v) <= 720) || $t('profiles.expirationValidation')]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="1" md="2">
                                                    <v-switch
                                                        :input-value="editedItem.is_administrador == 1 || editedItem.is_administrador === true"
                                                        @change="setAdministradorFlag"
                                                        :label="$t('profiles.administratorProfile')"
                                                        :disabled="!user || user.is_superadmin !== 1"
                                                        hide-details
                                                        class="mt-0"
                                                    />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <span class="subtitle-1 grey--text text--darken-2">{{ $t('profiles.ticketStatusesSection') }}</span>
                                                    <div class="text-caption grey--text">{{ $t('profiles.ticketStatusesHint') }}</div>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-autocomplete
                                                        v-model="editedItem.ids_status_tickets_colunas"
                                                        :items="statusTicketsCatalog"
                                                        item-text="status_ticket"
                                                        item-value="id_status_ticket"
                                                        multiple
                                                        chips
                                                        deletable-chips
                                                        clearable
                                                        dense
                                                        :label="$t('profiles.ticketStatusesBoardColumns')"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-autocomplete
                                                        v-model="editedItem.ids_status_tickets_select"
                                                        :items="statusTicketsCatalog"
                                                        item-text="status_ticket"
                                                        item-value="id_status_ticket"
                                                        multiple
                                                        chips
                                                        deletable-chips
                                                        clearable
                                                        dense
                                                        :label="$t('profiles.ticketStatusesInSelects')"
                                                    />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <span class="headline" style="color: #4a4a4a">{{ $t('profiles.permissions') }}</span>
                                                    <div class="text-caption grey--text">
                                                        {{ $t('profiles.scope.screensHint') }}
                                                        <router-link to="/permissoes-acesso">{{ $t('nav.accessPermissions') }}</router-link>.
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <v-autocomplete
                                                        v-model="perfilCopiaPermissoes"
                                                        :items="perfisParaCopia"
                                                        item-text="descricao_tipo_usuario"
                                                        item-value="id_perfil_usuario"
                                                        :label="$t('profiles.copyPermissionsFromProfile')"
                                                        :hint="editedIndex === -1 ? '' : $t('profiles.scope.copyReplacesHint')"
                                                        persistent-hint
                                                        clearable
                                                        dense
                                                    />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <span class="subtitle-1 grey--text text--darken-2">{{ $t('profiles.scope.title') }}</span>
                                                    <div class="text-caption grey--text">{{ $t('profiles.scope.hint') }}</div>
                                                </v-col>
                                                <v-col cols="12" sm="4" md="3">
                                                    <v-switch
                                                        v-model="escopo.unidades_todas"
                                                        :label="$t('profiles.scope.allUnits')"
                                                        hide-details
                                                        class="mt-0"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="8" md="4">
                                                    <MultiplaEscolha
                                                        v-show="!escopo.unidades_todas"
                                                        lazy
                                                        get-url="getUnidadeslazy"
                                                        text="descricao_unidade"
                                                        value="id_unidade"
                                                        :label="$t('nav.registration.units')"
                                                        :max-items="3"
                                                        v-bind:selected-items.sync="escopo.ids_unidades"
                                                    />
                                                </v-col>
                                                <v-col cols="12" sm="12" md="5">
                                                    <v-radio-group v-model="escopo.clientes" :label="$t('profiles.scope.clients')" class="mt-0" hide-details>
                                                        <v-radio :label="$t('profiles.scope.clientsAll')" value="todos" />
                                                        <v-radio :label="$t('profiles.scope.clientsOwn')" value="proprio" />
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                </template>
                </CadastroToolbar>
            </template>

                <template v-slot:item.is_administrador="{ item }">
                    <span>{{ item.is_administrador == 1 ? $t('system.yes') : $t('system.no') }}</span>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" color="green" @click="editItem(item)"
                        :disabled="!item.can_edit && !user.is_superadmin">mdi-pencil</v-icon>
                    <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
                        :disabled="!item.can_delete && !user.is_superadmin">mdi-delete</v-icon>
                </template>

            </merus-data-table>

        </v-container>
    </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import translateDbField from "@/utils/translateDbField";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
import { parsePerfilStatusIdsFromRow } from "@/utils/ticketStatusPerfilFilter";

function escopoPadrao() {
    return { unidades_todas: true, ids_unidades: [], clientes: 'proprio' };
}

function escopoDoPerfil(perfil) {
    return {
        unidades_todas: Number(perfil.escopo_unidades_todas) === 1,
        ids_unidades: perfil.ids_unidades_escopo
            ? String(perfil.ids_unidades_escopo).split(',').map(Number)
            : [],
        clientes: perfil.escopo_clientes || null,
    };
}

function escopoComparavel(escopo) {
    const ids = escopo.unidades_todas ? [] : [...(escopo.ids_unidades || [])].map(Number).sort((a, b) => a - b);
    return JSON.stringify([!!escopo.unidades_todas, ids, escopo.clientes || null]);
}

export default {
    name: 'PerfisUsuarios',
    components: {
        CadastroToolbar,
        MerusDataTable,
        MultiplaEscolha,
    },
    data: () => ({
        helpDialog: false,
        confirmDialog: false,
        showConfirmButton: false,
        mensagemdialog: "",
        messageDismissButton: "",
        messageConfirmButton: "",
        user: null,
        token: null,
        searchPerfis: "",
        perfilCopiaPermissoes: null,
        loadingPerfis: false,
        perfisSelected: [],
        perfis: [],
        displayedItemsForExport: null,
        telas: [],
        statusTicketsCatalog: [],
        // Escopo de dados do perfil (motor novo de permissões)
        escopo: escopoPadrao(),
        escopoOriginal: null,
        dialog: false,
        formValidado: false,
        editedIndex: -1,
        editedItem: {
            id_perfil_usuario: null,
            descricao_tipo_usuario: null,
            expira_token: null,
            expira_token_extenso: null,
            id_home_page: null,
            is_administrador: 0,
            ids_status_tickets_colunas: [],
            ids_status_tickets_select: [],
        },
        deletedItem: {
            id_perfil_usuario: null,
            descricao_tipo_usuario: null,
            expira_token: null,
            expira_token_extenso: null,
            id_home_page: null,
            is_administrador: 0,
            ids_status_tickets_colunas: [],
            ids_status_tickets_select: [],
        },
        defaultItem: {
            id_perfil_usuario: null,
            descricao_tipo_usuario: null,
            expira_token: null,
            expira_token_extenso: null,
            id_home_page: null,
            is_administrador: 0,
            ids_status_tickets_colunas: [],
            ids_status_tickets_select: [],
        },
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize()
        this.populaTelas();
        this.populaStatusTicketsCatalog();
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? this.$t('profiles.create')
                : this.$t('profiles.edit');
        },
        headersPerfis() {
            return [
            { text: this.$t('profiles.headers.profileId'), value: "id_perfil_usuario", align: " d-none" },
            { text: this.$t('profiles.headers.profile'), value: "descricao_tipo_usuario" },
            { text: this.$t('profiles.headers.tokenExpires'), value: "expira_token_extenso" },
            { text: this.$t('profiles.headers.expirationTime'), value: "expira_token" },
            { text: this.$t('profiles.headers.administrator'), value: "is_administrador" },
            { text: this.$t('profiles.headers.actions'), value: "actions", sortable: false, align: "end" }];
        },
        headersPerfisWithProperties() {
            return this.headersPerfis.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        perfisParaCopia() {
            const currentId = this.editedItem && this.editedItem.id_perfil_usuario;
            if (currentId == null) return this.perfis;
            return this.perfis.filter((p) => p.id_perfil_usuario !== currentId);
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    methods: {
        setAdministradorFlag(value) {
            this.editedItem.is_administrador = value ? 1 : 0;
        },
        prepareNewPerfil() {
            this.editedIndex = -1;
            this.editedItem = Object.assign({}, this.defaultItem);
            this.perfilCopiaPermissoes = null;
            this.carregarEscopo(escopoPadrao());
        },
        carregarEscopo(escopo) {
            this.escopo = escopo;
            this.escopoOriginal = escopoComparavel(escopo);
        },
        normalizeEditedItemStatusArrays() {
            this.editedItem.ids_status_tickets_colunas = parsePerfilStatusIdsFromRow(this.editedItem, "ids_status_tickets_colunas");
            this.editedItem.ids_status_tickets_select = parsePerfilStatusIdsFromRow(this.editedItem, "ids_status_tickets_select");
        },
        populaStatusTicketsCatalog() {
            apiController.request(apiController.endpoints.getallStatus, {
                onSuccess: (response) => {
                    let rows = Array.isArray(response.data) ? response.data : [];
                    this.statusTicketsCatalog = rows.filter((s) => s && (s.ativo === 1 || s.ativo === "1" || s.ativo == null));
                },
            });
        },
        initialize() {
            apiController.request(apiController.endpoints.getallPerfisusuarios, {
                onSuccess: (response) => {
                    this.perfis = response.data.map(perfil => {
                        const translated = translateDbField(
                            perfil.translation_key,
                            perfil.descricao_tipo_usuario
                        );
                        return {
                            ...perfil,
                            descricao_tipo_usuario: translated
                        };
                    });
                },
            });
        },
        populaTelas() {
            apiController.request(apiController.endpoints.getallRecursos, {
                onSuccess: (response) => {
                    this.telas = response.data.filter((t) => t.id_tipo_recurso == 2);
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.perfilCopiaPermissoes = null;
                this.$refs.form.resetValidation();
            });
        },
        save() {
            const data = { ...this.editedItem };
            if (this.perfilCopiaPermissoes) data.id_perfil_copia = this.perfilCopiaPermissoes;
            // Na edição, só manda o escopo se mudou: o servidor o substitui por inteiro
            if (this.editedIndex == -1 || escopoComparavel(this.escopo) !== this.escopoOriginal) {
                data.escopo = this.escopo;
            }
            apiController.request(
                this.editedIndex == -1 ? apiController.endpoints.insertPerfil : apiController.endpoints.updatePerfil,
                {
                    data,
                    onSuccess: (response) => {
                        this.updateTable(response.data);
                    },
                },
            );
        },
        deleteFromDatabase() {
            this.confirmDialog = false;
            apiController.request(apiController.endpoints.deletePerfil, {
                data: this.deletedItem,
                onSuccess: (response) => {
                    this.updateTable(response.data);
                },
            });
        },
        editItem(item) {
            this.editedIndex = this.perfis.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.normalizeEditedItemStatusArrays();
            this.perfilCopiaPermissoes = null;
            this.carregarEscopo(escopoDoPerfil(item));
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.mensagemdialog =
                this.$t('profiles.confirmation') + " " + item.descricao_tipo_usuario + " ?";
            this.showConfirmButton = true;
            this.messageDismissButton = this.$t('button.dismiss');
            this.messageConfirmButton = this.$t('button.confirm');
            this.confirmDialog = true;
        },
        updateTable(data) {
            EventBus.$emit('show-alert', {
                mensagem: data.mensagem,
                tipo: data.erro ? 'error' : 'success'
            });
            this.initialize();
            this.close();
        },
    }
}
</script>
<style lang="">

</style>